export default {
  base: [
    ['satellite-tracking/report.vehicle', 'vehicle'],
    ['satellite-tracking/report.drivers', 'drivers'],
    ['satellite-tracking/report.distance', 'distance']
  ],

  machine: [
    ['satellite-tracking/report.machine_hours', 'machineHoursTotal'],
    ['satellite-tracking/report.machine_hours_start', 'machineHoursStart'],
    ['satellite-tracking/report.machine_hours_end', 'machineHoursEnd'],
    ['satellite-tracking/report.driving_time', 'engineHours'],
    ['satellite-tracking/report.spent_fuel', 'spentFuel'],
    ['satellite-tracking/report.average_spent_fuel_machine', 'averageFuelSpentMachine']
  ],

  vehicle: [
    ['satellite-tracking/report.start_distance', 'startOdo'],
    ['satellite-tracking/report.end_distance', 'endOdo'],
    ['satellite-tracking/report.average_speed', 'averageSpeed'],
    ['satellite-tracking/report.maxSpeed', 'maxSpeed'],
    ['satellite-tracking/report.spent_fuel', 'spentFuel'],
    ['satellite-tracking/report.average_spent_fuel', 'averageFuelSpent'],
    ['satellite-tracking/report.engine_hours', 'engineHours']
  ]
}
